import React, { useState, useEffect } from 'react';
import {Modal, Button} from 'react-bootstrap'
import MyModalBody from './MyModalBody';
import ModalComments from "./ModalComments";
import { firebase } from "../../../firebase/firebaseConfig"
import { upvotePost } from "../../../firebase/writeData"
import { deletePost } from "../../../firebase/writeData";
import { useAuthState } from 'react-firebase-hooks/auth'
import { useHistory } from 'react-router-dom'

import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

export default function MyModal(props) {
  const [show, setShow] = useState(true);
  const [user] = useAuthState(firebase.auth());
  const [error, setError] = useState(false);
  const history = useHistory();

  let summary, upvotes, upvoters, postID, authorID, owner = '';
  let upvoted = false;
  if (props.modalData) {
      summary = props.modalData.summary; upvotes = props.modalData.upvotes;
      upvoters = props.modalData.upvoters; postID = props.modalData.postID;
      authorID = props.modalData.authorID;

      firebase.analytics().logEvent('post_click', {postID})
      if (user && user.uid === authorID) owner = true;
    if (user && upvoters.length !== 0 && upvoters[0] !== "" && upvoters.includes(user.uid)) {
      upvoted = true; }
  }

  const handleDelete = () => {
    let url; if (props.userURL) url = props.userURL; else url = "/forum";
    deletePost(postID, user.uid, url);
  }

  //Handle Close
  useEffect(() => {
    if (!show) {
      setTimeout(() => {
        if (props.userURL) history.push(props.userURL);
        else history.push('/forum');
      }, 500)
   }}, [show]);

  const handleUpvote = (postID, postUpvoters, summary) => {
    if (user) {
      if (postUpvoters.length !== 0 && postUpvoters[0] !== "" && postUpvoters.includes(user.uid)) {
        upvotePost({upvote: -1, authorID: user.uid, postID, postUpvoters, summary});
        
        const newUpvoters = props.modalData.upvoters.filter(author => author !== user.uid);
        if (props.handleVote) props.handleVote(newUpvoters, -1);
        props.setModalData({...props.modalData, upvoters: newUpvoters, upvotes: props.modalData.upvotes - 1});
      } else {
        upvotePost({upvote: 1, authorID: user.uid, postID, postUpvoters, summary});
        
        const newUpvoters = (props.modalData.upvoters && props.modalData.upvoters[0] !== "") ? [...props.modalData.upvoters, user.uid] : [user.uid];
        if (props.handleVote) props.handleVote(newUpvoters, +1);
        props.setModalData({...props.modalData, upvoters: newUpvoters, upvotes: props.modalData.upvotes + 1});
      }
    } else {
      setError(true);
    }
  }

  return props.modalData && (
    <div>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="detail-modalBG"
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header>
          <Modal.Title className="mr-auto">
            {summary}
          </Modal.Title>
          {owner && <Button variant="danger" className="mr-3" onClick={handleDelete}>Delete</Button>}
          <Button variant={upvoted ? "success" : "outline-success"} id="custom-modal-button" onClick={() => handleUpvote(postID, upvoters, summary)}>
            +{upvotes}
          </Button>
        </Modal.Header>
        <Modal.Body>
          <MyModalBody modalData={props.modalData}/>
          <ModalComments postID={props.modalData.postID} postSummary={summary} postOwner={authorID}/>
        </Modal.Body>
      </Modal>

      <Snackbar 
        open={error} 
        autoHideDuration={3000} 
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        key={'topcenter'}
        >
        <MuiAlert elevation={6} variant="filled" severity="error">
          Please sign in to upvote posts. 
        </MuiAlert>
      </Snackbar>
    </div>
  );
}